import { Box, FormControlLabel, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useColors from "../../../../../api/hooks/useColors";
import CustomSwitch from "../../../../../components/CustomSwitch";
import CustomTooltip from "../../../../../components/CustomTooltip";
import IconContainer from "../../../../../components/IconContainer";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import {
  icons,
  severities,
  workflowsIcons,
} from "../../../../stack/environment/icons/iconExport";
import { getIconByCategory } from "../../utils";
const WorkflowCardContent = ({ data, isTemplate = false }) => {
  const colors = useColors();
  const [cardActive, setCardActive] = useState(data.active);

  useEffect(() => {
    setCardActive(data.active);
  }, [data.active]);

  const tooltipTitle = (type, name) => {
    return (
      <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
        <Typography variant="overline">{type}:</Typography>

        <Typography variant="caption">{name}</Typography>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        justifyContent: "space-between",
        height: "100%",
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
            <Typography variant="subtitle1">{data.title}</Typography>
            {data.inUse && (
              <CustomTooltip
                title={
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Typography variant="caption">
                      <b>Created by:</b> {data.createdBy}
                    </Typography>
                    <Typography variant="caption">
                      <b>Created at:</b> {data.createdAt}
                    </Typography>
                  </Box>
                }
                placement="top"
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <SvgToIcon
                    IconLogo={severities.SeverityInfoTooltipIcon}
                    width="16px"
                    height="16px"
                  />
                </Box>
              </CustomTooltip>
            )}
          </Box>
          {data.inUse && !isTemplate && (
            <FormControlLabel
              sx={{
                background: colors.common_white,
                color: colors.contrast_text_dark,
                height: "32px",
                textTransform: "unset",
                borderRadius: "8px",
                margin: "0",
                gap: 1,
                padding: "8px",
              }}
              control={
                <CustomSwitch
                  checked={cardActive}
                  onChange={() => {
                    setCardActive(!cardActive);
                  }}
                />
              }
              label={""}
              labelPlacement="start"
            />
          )}
        </Box>
        <Typography variant="body2">{data.description}</Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
        {data.triggers?.map((item) => (
          <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
            <CustomTooltip
              title={tooltipTitle("Trigger", item.name)}
              placement="top"
            >
              <Box>
                <IconContainer IconSVG={workflowsIcons[item.type]} size="M" />
              </Box>
            </CustomTooltip>
          </Box>
        ))}
        {data.conditions?.map((item) => (
          <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
            <CustomTooltip
              title={tooltipTitle(
                "Condition",
                typeof item.type === "object"
                  ? item.type.name + " " + item.name
                  : item.name
              )}
              placement="top"
            >
              <Box>
                <IconContainer
                  IconSVG={
                    typeof item.type === "object"
                      ? getIconByCategory(item.type.type, item.typeChildren)
                      : workflowsIcons[item.type]
                  }
                  size="M"
                />
              </Box>
            </CustomTooltip>
          </Box>
        ))}
        <SvgToIcon IconLogo={icons.arrow} />
        {data.actions?.map((item) => (
          <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
            <CustomTooltip
              title={tooltipTitle("Action", item.name)}
              placement="top"
            >
              <Box>
                <IconContainer IconSVG={workflowsIcons[item.type]} size="M" />
              </Box>
            </CustomTooltip>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default WorkflowCardContent;
